<template>
    <div class="modal fade" id="change-therapist-modal" role="dialog">
        <div class="modal-dialog">
            <div class="modal-content" style="min-height: 600px;">
                <div class="modal-header">
                    <h5 class="modal-title">
                        <span>Ändra terapeut</span>
                    </h5>
                    <button type="button" class="close" data-dismiss="modal">
                        <span><b>x</b></span>
                    </button>
                </div>
                <div class="modal-body pb-5">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>{{transEdit('therapist')}}</label>
                                <vue-multiselect v-model="selectedTherapist" :options="filterTherapists" :max-height="130" label="name" placeholder="Välj terapeut" open-direction="below"></vue-multiselect>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>{{transEdit('start')}}</label>
                                <input type="date" class="form-control" name="period_start_therapist" id="period_start_therapist" autocomplete="off">
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>{{transEdit('end')}}</label>
                                <input type="date" class="form-control"  name="period_end_therapist" id="period_end_therapist" autocomplete="off">
                            </div>
                        </div>
                    </div>
                    <div class="row pb-20">
                        <div class="col-md-6">
                            <div>
                                <span v-if="loading"><i class="fa fa-spin fa-fw fa-refresh"></i> {{transEdit('loading')}}...</span>
                            </div>
                            <div class="text-danger">
                                <span v-if="error">{{transEdit('admin.schedules.create.conflicts-exist')}}</span>
                            </div>
                            <input class="hidden" id="change-therapist-modal-batch-hidden" v-model-inject="batch_id" @change="getTherapists($event.target.value)">
                            <input class="hidden" id="change-therapist-modal-date">

                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary"
                            v-on:click="updateTherapist"><i class="fa fa-pencil"></i> Ändra terapeut</button>
                    <button class="btn btn-dark"
                            data-dismiss="modal"><i class="fa fa-ban"></i>  {{transEdit('cancel')}}</button>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import VueMultiselect from "vue-multiselect/src/Multiselect";
    export default {
        name: "admin-schedules-batch-modal-change-therapist",
        components: {VueMultiselect},

        data() {
            return {
                therapists: [],
                selectedTherapist: null,
                loading: false,
                error: false,
                batch_id: null,
            }
        },
        computed: {
            filterTherapists() {
                let simplifiedTherapists = [];
                if(this.therapists){
                    for(let therapist of this.therapists) {
                        if(!therapist.user) {
                            return;
                        }

                        simplifiedTherapists.push({
                            id: therapist.id,
                            name: therapist.user.name,
                        });
                    }
                }

                return simplifiedTherapists;
            },
        },
        methods: {
            getTherapists(batch) {
                this.loading = true;
                axios.get('adminschedule/batch/therapists?batch_id=' + batch).then((res) => {
                    this.therapists = res.data;
                    this.loading = false;
                });
            },
            updateTherapist: function () {
                this.error = false;
                let thisModal = $("#change-therapist-modal");

                axios.post(this.$portalUrl('adminschedule/batch/changetherapist'), {
                    batch_id: this.batch_id,
                    therapist_id: this.selectedTherapist ? this.selectedTherapist.id : null,
                    current_date: $("#change-therapist-modal-date").val(),
                    start: $("#period_start_therapist").val(),
                    end: $("#period_end_therapist").val(),
                }).then((res) => {
                    this.loading = false;
                    this.$emit('refresh');
                    thisModal.modal('toggle');
                }).catch((res) => {
                    this.error = true;
                });
            },

            getTreatmentIds() {
                if(!this.selectedTreatment || !this.selectedTreatment.length) return [];
                let ids = [];
                for(let treatment of this.selectedTreatment) {
                    ids.push(treatment.id);
                }

                return ids;
            }
        },
        watch: {
            'batch_id': function(val, oldVal){
                this.getTherapists(val);
                this.loading = false;
            }
        },
        mounted() {
            this.loading = true;
        }
    }
</script>

<style scoped>

</style>
